import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttachmentsService } from 'src/app/services/attachments.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-delete-attachment',
    templateUrl: './delete-attachment.component.html',
    styleUrls: ['./delete-attachment.component.scss'],
    standalone: false
})
export class DeleteAttachmentComponent implements OnInit {
	@Output() deleteFile = new EventEmitter<boolean>();
	@Input () idFile: number;
	@Input () title: string;
	@Input () service: string;
	@Input () message: number = -1;
	loading: boolean = false;
  constructor(
		public activeModal: NgbActiveModal,
		private attachmentServ: AttachmentsService,
	) { }

  ngOnInit() {
  }
	confirmDelete(event) {
		if (event) {
			this.loading = true;
			this.attachmentServ.deleteAttachment(this.idFile, this.service).subscribe((resp) => {
				if (resp['error']) {
					this.loading = false;
					this.message = 0;
				} else {
					this.message = 1;
					this.loading = false;
					setTimeout(() => this.activeModal.dismiss(), 2000);
					setTimeout(() => this.deleteFile.emit(true), 2000);
				}
			});
		}
	}
}
